import axios from 'axios';
import Cookies from 'js-cookie';

import getTokenBearer from '@/hooks/getTokenBearer';
import { normalizeParentMe } from '@/helper/parentNormalize';
import { mockParentDashboard, mockParentMeFixtures } from '@/api/parentMocks';

const baseURL = import.meta.env.VITE_API_URL;

/** Live me/ is on api-dev (Postman). Set VITE_PARENT_ME_MOCK=true to force fixtures. */
const useMeMock = import.meta.env.VITE_PARENT_ME_MOCK === 'true';

/** Dashboard API not in Postman yet — always mock until BE ships it. */
const useDashboardMock = import.meta.env.VITE_PARENT_DASHBOARD_MOCK !== 'false';

function authHeaders(tokenOverride) {
	const token = tokenOverride || Cookies.get('wbAKey') || localStorage.getItem('wbAKey');
	return {
		Authorization: `${getTokenBearer()} ${token}`,
		'Content-Type': 'application/json',
	};
}

/**
 * Parent account APIs. Callers use the same functions whether mock or HTTP.
 * Paths follow BE Postman: outlet-parents/ (not the older parent/ plan names).
 */
export default function parent() {
	async function getParentMe(options = {}) {
		const { token, fixture = 'parentOneChild' } = options;

		if (useMeMock) {
			const data = mockParentMeFixtures[fixture] || mockParentMeFixtures.parentOneChild;
			return { data, status: 200, fromMock: true };
		}

		const response = await axios.get(`${baseURL}point-of-sale/outlet-parents/me/`, {
			headers: authHeaders(token),
		});
		return {
			...response,
			data: normalizeParentMe(response.data),
			fromMock: false,
		};
	}

	async function getParentDashboard(options = {}) {
		const { date, token, children } = options;

		if (useDashboardMock) {
			return {
				data: mockParentDashboard(date, children),
				status: 200,
				fromMock: true,
			};
		}

		const response = await axios.get(`${baseURL}point-of-sale/outlet-parents/dashboard/`, {
			headers: authHeaders(token),
			params: { date },
		});
		return { ...response, fromMock: false };
	}

	return {
		getParentMe,
		getParentDashboard,
	};
}
